import { useEffect, useRef, useState } from 'react'

type Selection = { name: string; input: HTMLInputElement; started: number }

export function LocalFileSelectionFeedback() {
  const [selection, setSelection] = useState<Selection | null>(null)
  const frame = useRef(0)

  useEffect(() => {
    const selected = (event: Event) => {
      const input = event.target
      if (!(input instanceof HTMLInputElement) || input.type !== 'file' || input.closest('[data-local-file-feedback]')) return
      const files = Array.from(input.files ?? [])
      if (!files.length) return
      const name = files.length === 1 ? files[0]!.name : `${files.length} files selected`
      setSelection({ name, input, started: performance.now() })
    }
    document.addEventListener('change', selected, true)
    return () => document.removeEventListener('change', selected, true)
  }, [])

  useEffect(() => {
    if (!selection) return
    const check = () => {
      const elapsed = performance.now() - selection.started
      if (!selection.input.isConnected || elapsed > 5_000) { setSelection(null); return }
      frame.current = requestAnimationFrame(check)
    }
    frame.current = requestAnimationFrame(check)
    return () => cancelAnimationFrame(frame.current)
  }, [selection])

  if (!selection) return null
  return <div className="local-file-selection-feedback" role="status" aria-live="polite">
    <span className="dropzone__spinner" aria-hidden="true" />
    <span><strong>{selection.name} selected</strong><small>Preparing locally…</small></span>
  </div>
}
